import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { store } from '~/shared/store/store';
import { UsersPage } from '~pages/users/UsersPage';
import { Logout } from '~pages/logout/Logout';
import { AuthCallback, Login } from '~pages/login/LoginPage';
import { AccountsPage } from '~pages/accounts/AccountsPage';
import { TemplatesPage } from '~/pages/templates/TemplatesPage';
import { HomePage } from '~pages/home/HomePage';
import { Wrapper } from '~pages/wrapper/Wrapper';
import { LaunchHistoryPage } from '~pages/launch-history/LaunchHistoryPage';
import { AccountLaunchHistoryPage } from '~pages/launch-history/AccountLaunchHistoryPage';
import { SnackbarProvider } from 'notistack';
import { CtaDictionaryPage } from '~/pages/dictionaries/CtaDictionaryPage';

const style = document.createElement('style');
style.textContent = `
  html, body, #root {
    height: 100%;
    margin: 0;
  }
`;
document.head.appendChild(style);

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: 'accounts',
      element: <AccountsPage />,
    },
    {
      path: 'templates',
      element: <TemplatesPage />,
    },
    {
      path: 'launch-history',
      element: <LaunchHistoryPage />,
    },
    {
      path: 'launch-history/account/:accountId',
      element: <AccountLaunchHistoryPage />,
    },
    {
      path: 'logout',
      element: <Logout />,
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'auth/callback',
      element: <AuthCallback />,
    },
    {
      path: 'users',
      element: <UsersPage />,
    },
    {
      path: 'dictionaries/cta',
      element: <CtaDictionaryPage />,
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  },
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <Wrapper>
        <SnackbarProvider maxSnack={3}>
          <RouterProvider router={router} />
        </SnackbarProvider>
      </Wrapper>
    </Provider>
  </StrictMode>,
);
